module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-BoldItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-BoldItalic.woff
 ** module id = 1096
 ** module chunks = 0
 **/